"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHumanReadable = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Converts a duration to a human readable string
 * @param duration Duration as moment duration object or number to be passed into moment duration constructor
 * @param options Render options
 */
const toHumanReadable = (duration, options = {
  seconds: true,
  milliseconds: false
}) => {
  duration = typeof duration === 'number' ? _moment.default.duration(duration) : duration;
  const hours = Math.floor(duration.asHours());
  let str = `${String(hours).padStart(2, '0')}:${String(duration.minutes()).padStart(2, '0')}`;
  if (options.seconds) {
    str = `${str}:${String(duration.seconds()).padStart(2, '0')}`;
    if (options.milliseconds) {
      str = `${str}.${String(duration.milliseconds()).padStart(3, '0')}`;
    }
  }
  return str;
};
exports.toHumanReadable = toHumanReadable;
//# sourceMappingURL=duration.js.map